import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

import { LuChevronDown, LuChevronLeft, LuChevronRight } from "react-icons/lu";

const PaginationDropdown = ({ label, value, className, variant, isOpen, setIsOpen, menuItems, setValue, type }) => {
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleLeftArrowClick = () => {
    if (value > 1) {
      setValue(value - 1);
    }
  };

  const handleRightArrowClick = () => {
    if (value < menuItems) {
      setValue(value + 1);
    }
  };

  const renderPageNumbers = () => {
    const currentPage = parseInt(value);
    const pageRange = Array.from({ length: menuItems }, (_, index) => index + 1);

    return pageRange.map((pageNumber) => (
      <MenuItem key={pageNumber} value={pageNumber} className="w-[75px] text-center">
        <p className={`w-full`}>{pageNumber}</p>
      </MenuItem>
    ));
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <p>{label}:</p>
      <FormControl variant={variant}>
        <Select
          value={value}
          label={label}
          onChange={handleChange}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            '&::before': { borderBottom: '0 !important' },
            '&::after': { borderBottom: '0 !important' },
            '& .MuiSelect-select': {
              padding: '10px 10px 10px 16px !important',
              '&:focus': { background: 'none' }
            },
            '& .MuiSvgIcon-root': { display: 'none' }
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 190,
                '& ul': {
                  scrollbarWidth: 'thin',
                  '&::-webkit-scrollbar': { display: 'none' }
                }
              }
            }
          }}
          open={isOpen}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
        >
          {type === "Rows" ? menuItems?.map((e, index) => {
            return <MenuItem key={index} value={e} className="w-[75px] text-center" children={<p className='w-full'>{e}</p>} />
          }) : renderPageNumbers()}
        </Select>
      </FormControl>
      <div className="p-1 cursor-pointer text-text-secondary" onClick={() => setIsOpen(!isOpen)}>
        <LuChevronDown size={18} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </div>
      {type === "Page" ? <p className="ml-4">of {menuItems}</p> : ""}
      {type === "Page" ? <div className="flex">
        <div className="flex items-center">
          <div className='p-2 cursor-pointer' onClick={handleLeftArrowClick}>
            <LuChevronLeft size={18} style={{ color: value === 1 ? 'var(--color-gray-300)' : 'var(--color-text-secondary)' }} />
          </div>
          <div className='p-2 cursor-pointer' onClick={handleRightArrowClick}>
            <LuChevronRight size={18} style={{ color: value === menuItems ? 'var(--color-gray-300)' : 'var(--color-text-secondary)' }} />
          </div>
        </div>
      </div> : ""}
    </div>
  );
};

export default PaginationDropdown;
